import {
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';
import type { MutableRefObject } from 'react';
import IdealContact from '../IdealContact';
import { HELP_MODAL_ID } from './constants';

const HelpModal: React.FunctionComponent = function () {
  return (
    <ModalContainer id={HELP_MODAL_ID} opacity={50}>
      {({ id, handleClose, ref }) => (
        <ModalLayoutCenter
          id={id}
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
          className="w-11/12 md:w-160"
        >
          <div className="flex flex-col gap-y-4">
            <p className="text-18-22-em w-full pr-8">Need Help?</p>
            <div className="border-b border-neutral-300 w-full" />
            <p>
              Got questions about something? Reach out to us on the numbers or
              emails below:
            </p>
            <IdealContact />
          </div>
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default HelpModal;
